<template>
  <b-modal v-model="show" size="lg" centered no-close-on-backdrop header-class="bg-modal-header" class="modal-dialog-right">

    <template #modal-header>
      <div class="fw-bold">월간 전체 충전 이력</div>
    </template>

    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between">
          <span class="fw-bold p-2">충전 이력</span>
          <span class="p-2">총 {{ chargingItems.length.toLocaleString() }} 건</span>
        </div>
        <div class="common-sticky-table">
          <b-table class="datatables text-nowrap"
                   outlined show-empty
                   responsive sticky-header="500px"
                   :fields="chargingFields" :items="chargingItems">
            <template #cell(startTime)="data">
              {{ $moment(data.item.startTime).format('YYYY-MM-DD hh:mm:ss') }}
            </template>
            <template #cell(chargeTime)="data">
              {{ $moment(data.item.startTime).format('hh시간 mm분') }}
            </template>
            <template #cell(totEnergy)="data">
              {{ $_utils.comma(data.item.totEnergy) }}
            </template>
            <template #cell(totCost)="data">
              {{ $_utils.comma(data.item.totCost) }} 원
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="fw-bold p-2 mt-2">이용한 충전소</div>
        <div class="common-sticky-table">
          <b-table class="datatables text-nowrap"
                   outlined show-empty
                   responsive sticky-header="500px"
                   :fields="stationFields" :items="usedStation">
          </b-table>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="show=false">닫기</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import cardTitle from "@/views/components/cardTitle.vue";
import { http } from "@/mdk/auth-api";

export default {
  name: 'UserChargingHistoryModal',
  components: { cardTitle },
  props: {
    month: String,
    userId: String,
    usedStation: Array,
  },
  data() {
    return {
      show: false,
      chargingFields: [
        { key: 'placeName', label: '충전소' },
        { key: 'csoEvseNum', label: '충전기' },
        { key: 'evseCapacity', label: '속도' },
        { key: 'startTime', label: '충전 시간', sortable: true },
        { key: 'chargeTime', label: '소요 시간', sortable: true },
        { key: 'totEnergy', label: '충전량', sortable: true },
        { key: 'totCost', label: '충전 요금', sortable: true },
      ],
      chargingItems: [],
      stationFields: [
        { key: 'place_name', label: '충전소' },
        { key: 'count', label: '충전 건수' },
      ],

    }
  },
  watch: {
    month: {
      handler() {
        const vm = this;
        vm.getHistoryItems();
      }
    },
    userId: {
      immediate: true,
      handler() {
        const vm = this;
        vm.getHistoryItems();
      }
    }
  },
  methods: {
    async getHistoryItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/charge-history`;
      const targetMonth = this.month;
      const userId = this.userId;

      try {
        const res = await http.get(_url, {
          params: { targetMonth, userId }
        });

        vm.chargingItems = [ ...res.data.items ];

      } catch (err) {
        console.error(err);
      }
    },
  }
}
</script>